import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "main", "trigger", "backdrop"]

  connect() {
    this.media = window.matchMedia("(max-width: 1100px)")
    this.resize = () => this.close()
    this.media.addEventListener("change", this.resize)
    this.element.classList.add("admin-drawer-ready")
    this.close()
  }

  disconnect() {
    this.close()
    this.media.removeEventListener("change", this.resize)
    this.element.classList.remove("admin-drawer-ready")
  }

  open() {
    if (!this.media.matches) return
    this.element.classList.add("admin-drawer-open")
    this.sidebarTarget.setAttribute("role", "dialog")
    this.sidebarTarget.setAttribute("aria-modal", "true")
    this.triggerTarget.setAttribute("aria-expanded", "true")
    this.mainTarget.inert = true
    this.backdropTarget.hidden = false
    document.body.classList.add("admin-drawer-lock")
    this.sidebarTarget.querySelector("button").focus()
  }

  close() {
    const hadFocus = this.sidebarTarget.contains(document.activeElement)
    this.element.classList.remove("admin-drawer-open")
    this.sidebarTarget.removeAttribute("role")
    this.sidebarTarget.removeAttribute("aria-modal")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.mainTarget.inert = false
    this.backdropTarget.hidden = true
    document.body.classList.remove("admin-drawer-lock")
    if (hadFocus) {
      if (this.media.matches) this.triggerTarget.focus()
      else this.sidebarTarget.focus()
    }
  }

  keydown(event) {
    if (!this.element.classList.contains("admin-drawer-open")) return
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
    }
    if (event.key !== "Tab") return
    const controls = [...this.sidebarTarget.querySelectorAll("a[href], button, select, [tabindex='0']")]
      .filter(element => !element.disabled && element.getClientRects().length)
    const first = controls[0]
    const last = controls[controls.length - 1]
    if (event.shiftKey && (document.activeElement === first || document.activeElement === this.sidebarTarget)) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }
}
